import { DynamicRoute } from '../../shared/navigation/dynamic-route';
import { NeverShowRouteResolver } from '../../shared/navigation/never-show-route-resolver';
import { PermissionLevel } from '../../shared/permission/permission';
import { WaiterMobileComponent } from './waiter-mobile.component';

export const waiterMobileRoutes: Array<DynamicRoute> = [
  {
    path: 'waiter-mobile',
    component: WaiterMobileComponent,
    data: {
      show: NeverShowRouteResolver,
      title: 'Receipts',
      permissionLevel: PermissionLevel.EMPLOYEE,
      type: []
    }
  }
];
